import { useCallback, useEffect } from 'react';

import { useWalletView } from '#/features/wallet/wallet-context';

import usePrevious from '#/utils/usePrevious';

import { useNotificationsActions } from './notifications-context';

export default function useResetNotificationsOnSignOut(): void {
  const notificationsActions = useNotificationsActions();
  const resetNotifications = useCallback(() => {
    notificationsActions.reset();
  }, [notificationsActions]);
  useSignOutHandler(resetNotifications);
}

function useSignOutHandler(handler: () => void): void {
  const walletView = useWalletView();
  const prevIsSignedIn = usePrevious(walletView.isSignedIn);

  useEffect(() => {
    if (prevIsSignedIn == null) return;
    if (walletView.isSignedIn) return;

    const isSignedOut = prevIsSignedIn && !walletView.isSignedIn;

    if (isSignedOut) {
      handler();
    }
  }, [handler, prevIsSignedIn, walletView.isSignedIn]);
}
